import React, { useState } from 'react';
import './CreatorLanding.css';

const CreatorSpecialOffer = () => {
  const [isProcessing, setIsProcessing] = useState(false);

  const handleCheckout = async () => {
    setIsProcessing(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/create-creator-special-checkout`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          offerType: 'gemma_special',
          duration: '18_months'
        })
      });

      const { url } = await response.json();
      window.location.href = url;
    } catch (error) {
      console.error('Error creating checkout:', error);
      alert('Error processing payment. Please try again.');
      setIsProcessing(false);
    }
  };

  return (
    <div className="creator-landing-container">
      <div className="special-offer-container" style={{
        minHeight: '100vh',
        background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(7, 34, 49, 0.7)), url("/images/archedbackground.webp") center/cover',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem'
      }}>

        <div style={{
          background: 'white',
          borderRadius: '20px',
          padding: '3rem',
          maxWidth: '500px',
          width: '100%',
          textAlign: 'center',
          boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
        }}>
          <img
            src="/images/logodownsized.webp"
            alt="BackPass"
            style={{ width: '150px', marginBottom: '2rem' }}
          />

          <h1 style={{
            fontSize: '2.5rem',
            marginBottom: '1rem',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontFamily: "'Caveat', cursive"
          }}>
            Hey Gemma!
          </h1>

          <div style={{
            background: '#f8f9fa',
            padding: '1.5rem',
            borderRadius: '10px',
            marginBottom: '2rem'
          }}>
            <p style={{ fontSize: '1.2rem', marginBottom: '1rem', color: '#333' }}>
              <strong>Your Exclusive Deal</strong>
            </p>
            <p style={{ fontSize: '1.1rem', color: '#333', marginTop: '1rem' }}>
              18-Month Route
            </p>
          </div>

          <button
            onClick={handleCheckout}
            disabled={isProcessing}
            style={{
              width: '100%',
              padding: '1rem',
              fontSize: '1.2rem',
              background: isProcessing ? '#ccc' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '10px',
              cursor: isProcessing ? 'not-allowed' : 'pointer',
              fontWeight: 'bold',
              transition: 'transform 0.2s',
              transform: isProcessing ? 'scale(1)' : 'scale(1.02)'
            }}
          >
            {isProcessing ? 'Processing...' : 'Complete Registration →'}
          </button>

          <p style={{ marginTop: '1rem', color: '#666', fontSize: '0.9rem' }}>
            🔒 Secure payment via Stripe
          </p>
        </div>
      </div>
    </div>
  );
};

export default CreatorSpecialOffer;